var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCiscoRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.98242,26.55322A28.92523,28.92523,0,0,1,69.25,40,29.28292,29.28292,0,0,1,40,69.25a28.99035,28.99035,0,0,1-20.60278-8.5H26v-1.5H18a.7502.7502,0,0,0-.75.75v8h1.5V62.218A30.47123,30.47123,0,0,0,40,70.75,30.76074,30.76074,0,0,0,67.31445,25.86279Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.75,20V12h-1.5v5.782A30.47123,30.47123,0,0,0,40,9.25,30.76074,30.76074,0,0,0,12.68555,54.13721l1.332-.69043A28.92523,28.92523,0,0,1,10.75,40,29.28292,29.28292,0,0,1,40,10.75a28.99035,28.99035,0,0,1,20.60278,8.5H54v1.5h8A.7502.7502,0,0,0,62.75,20Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25,40.73242v1.4917a.75.75,0,0,0,1.5,0v-1.4917a.75.75,0,1,0-1.5,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.25,38.75391v3.47021a.75.75,0,0,0,1.5,0V38.75391a.75.75,0,1,0-1.5,0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25,36v7.65527a.75.75,0,0,0,1.5,0V36a.75.75,0,0,0-1.5,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.25,38.75391v3.47021a.75.75,0,0,0,1.5,0V38.75391a.75.75,0,1,0-1.5,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.25,40.73682v1.4873a.75.75,0,0,0,1.5,0v-1.4873a.75.75,0,1,0-1.5,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.25,38.75391v3.47021a.75.75,0,0,0,1.5,0V38.75391a.75.75,0,1,0-1.5,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.25,36v7.65527a.75.75,0,0,0,1.5,0V36a.75.75,0,0,0-1.5,0Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.25,38.75391v3.47021a.75.75,0,0,0,1.5,0V38.75391a.75.75,0,1,0-1.5,0Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.25,40.73242v1.4917a.75.75,0,0,0,1.5,0v-1.4917a.75.75,0,1,0-1.5,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCiscoRefresh);
export default __webpack_public_path__ + "static/media/icon_cisco_refresh.f22499e7aada641ad86d89042d3574f5.svg";
export { ForwardRef as ReactComponent };